import BASE_URL from "../../config";

export const CATEGORY_META = {
  astrology: {
    label: "Astrology",
    title: "Astrology Consultation",
    blurb: "Birth chart, career, relationships, wellbeing and yearly guidance.",
    symbol: "☉",
  },
  numerology: {
    label: "Numerology",
    title: "Numerology Consultation",
    blurb: "Mobile numbers, names, business names and event predictions.",
    symbol: "№",
  },
  vastu: {
    label: "Vastu",
    title: "Vastu Consultation",
    blurb: "Home, office and commercial Vastu with practical remedies.",
    symbol: "✦",
  },
};

export const CATEGORY_ORDER = ["astrology", "numerology", "vastu"];

export const formatINR = (value) =>
  `₹${Number(value || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

// Uploaded files are served from the API origin, not under /api/v1.
export const resolveImage = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  const origin = BASE_URL.endsWith("/api/v1") ? BASE_URL.slice(0, -7) : BASE_URL;
  return `${origin}${path}`;
};

export const initials = (name) =>
  String(name || "?")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");

// All consultation times are shown in IST regardless of the visitor's timezone.
export const formatSlotTime = (iso) =>
  new Date(iso).toLocaleTimeString("en-IN", {
    timeZone: "Asia/Kolkata",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

export const formatSlotDateTime = (iso) =>
  new Date(iso).toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

// "2026-10-05" -> { day: "Mon", date: "5", month: "Oct" } (no timezone shifts)
export const dateChipParts = (dateStr) => {
  const [y, m, d] = dateStr.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  const opts = { timeZone: "UTC" };
  return {
    day: dt.toLocaleDateString("en-IN", { ...opts, weekday: "short" }),
    date: String(d),
    month: dt.toLocaleDateString("en-IN", { ...opts, month: "short" }),
  };
};
